<template>
  <div>
    <p
      v-if="label"
      class="label"
    >
      {{ label }}
    </p>
    <p
      v-if="message"
      class="message"
    >
      {{ message }}
    </p>
    <v-chip
      v-for="day in weeklyDays"
      :key="`week-day-${day.number}`"
      class="mr-2 py-1 px-4"
      :color="days.includes(day.number) ? 'primary' : ''"
      @click="select(day.number)"
    >
      {{ day.letter }}
    </v-chip>
  </div>
</template>

<style scoped>
  .label {
    margin-top: 0 !important;
    font-size: 0.9rem;
  }

  .message {
    margin-top: -0.2rem !important;
    margin-bottom: 0.8rem;
    font-size: 0.7rem;
  }
</style>

<script>
export default {
  props: {
    days: {
      type: Array,
      required: true,
    },

    selectable: {
      type: Boolean,
      default: false,
    },

    label: {
      type: String,
      default: null,
    },

    message: {
      type: String,
      default: null,
    },
  },

  computed: {
    weeklyDays() {
      return [
        { number: 0, letter: 'D' },
        { number: 1, letter: 'S' },
        { number: 2, letter: 'T' },
        { number: 3, letter: 'Q' },
        { number: 4, letter: 'Q' },
        { number: 5, letter: 'S' },
        { number: 6, letter: 'S' },
      ];
    },
  },

  methods: {
    select(dayNumber) {
      if (this.selectable) {
        const dayNumberPosition = this.days.indexOf(dayNumber);

        if (dayNumberPosition > -1) {
          this.days.splice(dayNumberPosition, 1);
        } else {
          this.days.push(dayNumber);
        }
      }
    },
  },
};
</script>
